"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExperimentState = exports.ExperimentProvider = void 0;
const react_1 = __importStar(require("react"));
const experiment_1 = require("../utils/experiment");
const defaultExperimentState = {
    experiments: [],
};
const ExperimentStateContext = react_1.default.createContext(defaultExperimentState);
/**
 * Experiment Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <ExperimentProvider>
 *   <Component />
 * </ExperimentProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useExperimentState();
 * ```
 * Call dispatch to update the context state
 * ```
 * const dispatch = useExperimentDispatch();
 * dispatch({ type: ACTION_TYPE, payload: ACTION_PAYLOAD });
 * ```
 */
const ExperimentProvider = (props) => {
    const { experiments, children } = props;
    const state = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, defaultExperimentState), { experiments })), [experiments]);
    react_1.default.useEffect(() => {
        (0, experiment_1.setExperimentCookie)(state === null || state === void 0 ? void 0 : state.experiments);
    }, []);
    return (react_1.default.createElement(ExperimentStateContext.Provider, { value: state }, children));
};
exports.ExperimentProvider = ExperimentProvider;
const useExperimentState = () => {
    const context = react_1.default.useContext(ExperimentStateContext);
    if (context === undefined) {
        throw new Error("useExperimentState must be used within the ExperimentProvider");
    }
    return context;
};
exports.useExperimentState = useExperimentState;
ExperimentProvider.displayName = "ExperimentProvider";
useExperimentState.displayName = "useExperimentState";
